import { axiosClient } from "@/shared/api/axios-client";
import type { Configuracion } from "@/lib/types";

export async function listarConfiguraciones(): Promise<Configuracion[]> {
  const { data } = await axiosClient.get<Configuracion[]>("/api/admin/configuraciones");
  return data;
}

export async function editarConfiguracion(
  clave: string,
  valor: string,
): Promise<Configuracion> {
  const { data } = await axiosClient.put<Configuracion>("/api/admin/configuraciones", {
    clave,
    valor,
  });
  return data;
}

export async function restablecerConfiguracion(clave: string): Promise<Configuracion> {
  const { data } = await axiosClient.post<Configuracion>(
    "/api/admin/configuraciones/restablecer",
    { clave },
  );
  return data;
}
